// extracted by mini-css-extract-plugin
module.exports = {"si-status-item-skeleton":"siStatusSkeletons_si-status-item-skeleton__jgJjv","mobile-only":"siStatusSkeletons_mobile-only__AaG1s"};